import { Icon, Link, Tooltip } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

export const SpanishDPRCheckmarkDocumentaryEvidenceViewer = ({
  state,
}: {
  state: 'ongoing' | 'done' | 'not-applicable';
}) => {
  const { t } = useTranslation('global');

  const isDone = state === 'done';
  const isOngoing = state === 'ongoing';

  const iconName = isDone ? 'shield-star' : 'clock-filled';

  return (
    <Tooltip
      content={
        isOngoing
          ? t('payables.spanishDPR.ongoingTooltip')
          : t('payables.spanishDPR.doneTooltip')
      }
      placement="top"
      triggerAsChild
    >
      <div className="flex items-center gap-4 body-m">
        <Icon name={iconName} size="s" className="text-content-secondary-bg-primary" />

        <Link
          className="text-content-secondary-bg-primary body-m"
          href={t('payables.spanishDPR.readMoreLink')}
        >
          {state === 'ongoing'
            ? t('payables.spanishDPR.shortenOngoingTitle')
            : t('payables.spanishDPR.shortenDoneTitle')}
        </Link>
      </div>
    </Tooltip>
  );
};
